/**
 * Статус локального матча в истории (Match.localStatus).
 *
 * Запись локальной партии создается в момент ее СТАРТА (in_progress), а не по
 * окончании: по незавершенным партиям видно, где игроки их бросают. Итоги
 * партии переводят запись в completed.
 *
 * У старых локальных матчей и у итогов от старого клиента (без runId) статуса
 * нет вовсе — они считаются завершенными. Нынешний клиент присылает runId
 * всегда, поэтому и партия, сохраненная только по итогам (запись на старте
 * не велась — миссия, режим зрителя — или не дошла до сервера), получает
 * сразу completed.
 */
export const LOCAL_MATCH_STATUSES = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
};
